import http_request from './http_request'
import config from 'config'

function dmStorageExperimentCompleted() {
	return http_request.post(config.services + 'user/loginNotification.php')
		.send({
			featureType: 'FEATURE_DECEMBER_DM_EXPERIMENT',
		})
}

function sendEmailToDM(firstName, lastName, email, phoneNumber, role) {
	return http_request.post(`${config.api}dm_onboarding`)
		.send({
			name: firstName,
			lastName,
			email,
			phoneNumber,
			role,
		})
}

export default {
	sendEmailToDM,
	dmStorageExperimentCompleted,
}
